import { api, createCancelTokenHandler } from '../vodea/services';
// import qs from 'query-string';
import useEcho from '../vodea/utilities/hooks/useEcho';

const endPoint = () => window._env_.REACT_APP_PASSPORT_END_POINT;

// const queryParams = () => {
//  return qs.parse(window.location.search);
// };

const Repository = {
  all: function (params: any = null) {
    // const { notif_id: notifId } = queryParams();
    return api.get(`${endPoint()}/api/cut-off`, {
      params: {
        ...params,
        // notif_id: notifId
      },
      cancelToken: cancelTokenHandlerObject[this.all.name].handleRequestCancellation().token
    });
  },
  show: function (id: number | string, params: any = null, useCancelToken = true) {
    // const { notif_id: notifId } = queryParams();
    return api.get(`${endPoint()}/api/cut-off/${id}`, {
      params: {
        ...params,
        // notif_id: notifId
      },
      cancelToken: useCancelToken ? cancelTokenHandlerObject[this.show.name].handleRequestCancellation().token : false
    });
  },
  select: function (params: any = null) {
    return api.get(`${endPoint()}/api/cut-off`, {
      params,
      cancelToken: cancelTokenHandlerObject[this.select.name].handleRequestCancellation().token
    });
  },
  create: function (payload: any, params: any = null) {
    return api.post(`${endPoint()}/api/cut-off`, payload, {
      params,
      cancelToken: cancelTokenHandlerObject[this.create.name].handleRequestCancellation().token
    });
  },
  update: function (id: number | string, payload: any, params: any = null) {
    return api.put(`${endPoint()}/api/cut-off/${id}`, payload, {
      params,
      cancelToken: cancelTokenHandlerObject[this.update.name].handleRequestCancellation().token
    });
  },
  delete: function (id: number | string, params: any = null) {
    return api.delete(`${endPoint()}/api/cut-off/${id}`, {
      params,
      cancelToken: cancelTokenHandlerObject[this.delete.name].handleRequestCancellation().token
    });
  }
};

export default Repository;

const cancelTokenHandlerObject = createCancelTokenHandler(Repository);
